'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { CourseCatalogCard } from '@/components/enrollment/course-catalog-card';
import { Button } from '@/components/ui/button';
import type { PublicCourseWithMidTerm } from '@/server/services/course.service';

/**
 * Client view for the featured-courses section. The async server fetch stays in
 * `featured-courses-section.tsx`; this just renders the (now translated) heading
 * + CTA around the catalog cards.
 */
export function FeaturedCoursesSectionView({ courses }: { courses: PublicCourseWithMidTerm[] }) {
  const t = useTranslations('public.featuredCourses');
  return (
    <section className="bg-[var(--eifo-bg-light)] py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4">
        <h2 className="font-display mb-12 text-center text-3xl font-bold text-eifo-primary md:text-4xl">
          {t('heading')}
        </h2>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {courses.map((course) => (
            <CourseCatalogCard key={course.id} course={course} />
          ))}
        </div>
        <div className="mt-10 text-center">
          <Button asChild size="lg" variant="outline">
            <Link href="/courses">{t('viewAll')}</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
